<template>
  <div>
    <AppBreadcrumbs :breadcrumbs="breadcrumbs" />

    <h1 class="mt-4 text-h4">
      Лучшие врачи и&nbsp;клиники в&nbsp;{{ year }}&nbsp;году
      в&nbsp;<span v-html="cityIn" />
    </h1>
  </div>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'
import type { IBreadcrumb, ISimpleRegion } from '~/types'

const props = defineProps({
  region: { type: Object as PropType<ISimpleRegion>, required: true },
  year: { type: Number, required: true },
  breadcrumbs: { type: Array as PropType<IBreadcrumb[]>, default: () => [] },
})

const cityIn = computed(() => props.region.prepositional_form
  .replace(/-/, '&#8209;') // Ханты-Мансийск (неразрывно)
  .replace(/ — /, '&nbsp;— '), // АО — (Перенос) Югра
)
</script>
